
import { FLIGHT_ITINERARY_TYPE, FLIGHT_ITINERARY_TYPE_MICRO } from "@app/enums";
import { PassengerAWSInt } from "@app/interfaces/reservation-aws.interface";
import { Segment } from "@app/models/cart/segment.model";
import { Passenger } from "@app/models/micro/passenger.model";
import { Reservation } from "@app/models/micro/reservation.model";
import { environment } from "@env/environment";

export class PnrAWSMapper {

  private static reservations: Reservation[];

  constructor() { }

  static pnrBuild(pnr, location) {
    this.reservations = [];
    let reservation: Reservation;

    if (pnr) {
      // Verificar FARELOCK antes de validaciones
      if (pnr.typeReservation === 'FARELOCK') {
        throw ({ code: 'FARELOCK', msg: 'FARELOCK reservation status', typeReservation: 'FARELOCK', rawData: pnr });
      }
      let oldLegs = pnr.oldBookedLegCollection;
      let legs:any[] = pnr.bookedLegCollection;
      let kioskLocation = location

      const flightType = {
        [FLIGHT_ITINERARY_TYPE_MICRO.ONEWAY]: FLIGHT_ITINERARY_TYPE.ONEWAY,
        [FLIGHT_ITINERARY_TYPE_MICRO.ROUNDTRIP]: FLIGHT_ITINERARY_TYPE.ROUNDTRIP,
        [FLIGHT_ITINERARY_TYPE_MICRO.MULTICITY]: FLIGHT_ITINERARY_TYPE.MULTICITY,
      };
      let bookedLeg = legs.find(x => x.segments.find(segment => segment.windowSegmentStatus == 'CKI'))
      let oldBookedLeg = oldLegs.find(x => x.segments.find(segment => segment.windowSegmentStatus == 'CKI'))

      if(!bookedLeg){
        const bookedLegs = legs.filter(x => x.segments.find(segment =>
          (segment.windowSegmentStatus === "IN_FLIGHT" || segment.windowSegmentStatus === "MYB" || segment.windowSegmentStatus === "CLOSED")))
          bookedLeg =  bookedLegs.find(x=> x.windowLegStatus == 'IN_FLIGHT' || x.windowLegStatus == 'MYB');
          if(!bookedLeg){
            bookedLeg = bookedLegs.reverse()[0];
          }
      }

      if(!oldBookedLeg && oldLegs.length > 0 ){
        const oldBookedLegs = oldLegs.filter(x => x.segments.find(segment =>
          (segment.windowSegmentStatus === "IN_FLIGHT" || segment.windowSegmentStatus === "MYB" || segment.windowSegmentStatus === "CLOSED")))

          oldBookedLeg =  oldBookedLegs.find(x=> x.windowLegStatus == 'IN_FLIGHT' || x.windowLegStatus == 'MYB');
          if(!oldBookedLeg){
            oldBookedLeg = oldBookedLegs.reverse()[0];
          }
      }

      if (bookedLeg) {
        reservation = new Reservation({ pnrCode: pnr.reservationCode, pnr, leg: bookedLeg, oldLeg: oldBookedLeg, kioskLocation });
        const indexLeg = legs.findIndex(leg=> leg.legCode == bookedLeg.legCode);
        reservation.flightItineraryType = flightType[pnr.tripType];
        reservation.flightSummary.itineraryPartType = indexLeg ==  1 && reservation.flightItineraryType == FLIGHT_ITINERARY_TYPE.ROUNDTRIP ?  'inbound' : 'outbound';

        if (pnr.corporateRecognition) {
          if (pnr.corporateRecognition && pnr.corporateRecognition.logo) {
            pnr.corporateRecognition.companyLogo = `${environment.cmsUrl}/sites/default/files/${pnr.corporateRecognition.spid}.png`
          }
        }
        reservation.passengers = this.buildPassengers(pnr.passengers, reservation)
        reservation.isAgencyReservation = pnr.isAgencyReservation
        reservation.isStandByBooking = this.isStandByBooking(pnr.passengers);
        const onHoldNnoTickets = reservation.passengers.some((p)=> !p.ticketInfo)
        if(onHoldNnoTickets) {
          throw ({code:20, msg:"error on hold"})
        }
        this.reservations.push(reservation);
      }
    }

    return this.reservations;
  }

  private static buildPassengers(passengers: PassengerAWSInt[],reservation?:Reservation): Passenger[] {
    let paxes: Passenger[] = [];

    if (passengers && passengers.length > 0) {
      for (let paxIndex of passengers) {
        let passenger = new Passenger(paxIndex,reservation); // .buildBagsUsedByRemarks(reservation.remarks);
        paxes.push(passenger);
      }
    }

    return paxes;
  }

  private static isStandByBooking(passengers) {
    for (let index = 0; index < passengers.length; index++) {
      let passenger = passengers[index];

      if (passenger.passengerType === 'E') {
        return true;
      }
    }

    return false;
  }
}
